/* Claude 2026-10-19: Paketinslagning i varukorgen (ersätter appen Wrapped).
   Sparar ordern på samma sätt som tidigare:
   - produkten får _Gift Wrap, _Gift Option, _Gift Sender, _Gift Message och _Wrapped Bundle (GW-1, GW-2 …)
   - en rad "Paketinslagning" (vald variant, samma antal) med samma _Wrapped Bundle läggs till.
   Raden för paketinslagningen visas ihop med produkten i varukorgen (se snippets/cart-item.liquid).
   Om kunden ändrar antal eller tar bort produkten följer paketinslagningen med automatiskt. */
(function(){
  if(window.__claudeGiftwrap)return;window.__claudeGiftwrap=1;
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var GIFT='gift-wrap';
  var KEYS=['_Gift Wrap','_Gift Option','_Gift Sender','_Gift Message','_Wrapped Bundle','_Gift Option ID','Gift Wrap','Gift Option','Gift Sender','Gift Message'];
  var busy=false;

  function post(url,body){
    return fetch(ROOT+url,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)})
      .then(function(r){if(!r.ok)throw r;return r.json();});
  }
  function getCart(){return fetch(ROOT+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();});}
  function money(c){try{return theme.Currency.formatMoney(c,theme.settings.moneyFormat);}catch(e){return Math.round(c/100)+' kr';}}
  function bundleOf(i){return (i.properties&&i.properties['_Wrapped Bundle'])||'';}
  function isWrap(i){return i.handle===GIFT;}
  function cleanProps(p){var o={};for(var k in (p||{})){if(KEYS.indexOf(k)<0&&p[k]!==null&&p[k]!=='')o[k]=p[k];}return o;}
  function rebuild(){
    if(document.getElementById('CartPageForm')&&!document.getElementById('CartDrawer')){location.reload();return;}
    document.dispatchEvent(new CustomEvent('cart:build'));
    if(document.getElementById('CartPageForm'))setTimeout(function(){location.reload();},150);
  }

  function open(box,on){
    var panel=box.querySelector('[data-cgw-panel]'),close=box.querySelector('[data-cgw-close]');
    panel.hidden=!on;if(close)close.hidden=!on;
    box.classList.toggle('is-open',on);
    if(on){var s=box.querySelector('[data-cgw-sender]');if(s&&window.matchMedia('(hover:hover)').matches)s.focus({preventScroll:true});}
  }
  function total(box){
    var o=box.querySelector('[data-cgw-opt]:checked'),t=box.querySelector('[data-cgw-total]');
    if(o&&t)t.textContent=money(+o.getAttribute('data-price')*(+box.getAttribute('data-qty')||1));
  }
  function setBusy(box,on){box.classList.toggle('is-busy',on);box.querySelectorAll('button,input,textarea').forEach(function(x){if(on)x.setAttribute('data-was-disabled',x.disabled?'1':'');x.disabled=on?true:x.getAttribute('data-was-disabled')==='1';});}

  /* Byter ut produktraden mot en ny med exakt rätt fält (Shopify kan inte ta bort enskilda fält på en rad).
     Raden tas bort tillsammans med ev. gammal paketinslagning och läggs till igen, ev. med ny inslagning. */
  function replaceLine(c,line,props,wrapId,bundle){
    var upd={};upd[line.key]=0;
    var old=bundleOf(line);
    c.items.forEach(function(i){if(old&&isWrap(i)&&bundleOf(i)===old)upd[i.key]=0;});
    var item={id:line.variant_id,quantity:line.quantity};
    if(Object.keys(props).length)item.properties=props;
    if(line.selling_plan_allocation&&line.selling_plan_allocation.selling_plan)item.selling_plan=line.selling_plan_allocation.selling_plan.id;
    var items=[item];
    if(wrapId)items.push({id:wrapId,quantity:line.quantity,properties:{'_Wrapped Bundle':bundle}});
    return post('cart/update.js',{updates:upd}).then(function(){return post('cart/add.js',{items:items});});
  }

  function save(box){
    var opt=box.querySelector('[data-cgw-opt]:checked');if(!opt)return;
    var sender=(box.querySelector('[data-cgw-sender]').value||'').trim();
    var msg=(box.querySelector('[data-cgw-msg]').value||'').trim();
    var key=box.getAttribute('data-key');
    busy=true;setBusy(box,true);
    getCart().then(function(c){
      var line=null;c.items.forEach(function(i){if(i.key===key)line=i;});
      if(!line)throw new Error('line');
      var bundle=bundleOf(line);
      if(!bundle||!/^GW-\d+$/.test(bundle)){
        var used={};c.items.forEach(function(i){var b=bundleOf(i);if(b)used[b]=1;});
        var n=1;while(used['GW-'+n])n++;bundle='GW-'+n;
      }
      var props=cleanProps(line.properties);
      props['_Gift Wrap']='yes';
      props['_Gift Option']=opt.getAttribute('data-title');
      if(sender)props['_Gift Sender']=sender;
      if(msg)props['_Gift Message']=msg;
      props['_Wrapped Bundle']=bundle;
      return replaceLine(c,line,props,+opt.value,bundle);
    }).then(function(){busy=false;rebuild();})
      .catch(function(){busy=false;setBusy(box,false);rebuild();});
  }

  function remove(box){
    var key=box.getAttribute('data-key');
    busy=true;setBusy(box,true);
    getCart().then(function(c){
      var line=null;c.items.forEach(function(i){if(i.key===key)line=i;});
      if(!line)throw new Error('line');
      return replaceLine(c,line,cleanProps(line.properties),0,'');
    }).then(function(){busy=false;rebuild();})
      .catch(function(){busy=false;setBusy(box,false);rebuild();});
  }

  /* Håller paketinslagningen i takt med produkten: samma antal, och den tas bort om produkten tas bort. */
  var syncT;
  function sync(){
    if(busy)return;
    getCart().then(function(c){
      if(busy)return;
      var prod={},seen={},upd={},need=false;
      c.items.forEach(function(i){var b=bundleOf(i);if(b&&!isWrap(i))prod[b]=(prod[b]||0)+i.quantity;});
      c.items.forEach(function(i){
        var b=bundleOf(i);if(!b||!isWrap(i))return;
        if(!prod[b]||seen[b]){upd[i.key]=0;need=true;return;}
        seen[b]=1;
        if(i.quantity!==prod[b]){upd[i.key]=prod[b];need=true;}
      });
      if(need){busy=true;post('cart/update.js',{updates:upd}).then(function(){busy=false;rebuild();}).catch(function(){busy=false;});}
    }).catch(function(){});
  }
  function soonSync(){clearTimeout(syncT);syncT=setTimeout(sync,400);}

  document.addEventListener('change',function(e){
    var t=e.target;
    if(t.matches&&t.matches('[data-cgw-toggle]')){
      var box=t.closest('[data-cgw]');
      if(t.checked)open(box,true);
      else if(box.getAttribute('data-on')==='true')remove(box);
      else open(box,false);
    }
    if(t.matches&&t.matches('[data-cgw-opt]'))total(t.closest('[data-cgw]'));
  });
  document.addEventListener('input',function(e){
    var t=e.target;
    if(t.matches&&t.matches('[data-cgw-msg]')){var c=t.closest('[data-cgw]').querySelector('[data-cgw-count]');if(c)c.textContent=t.value.length;}
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-cgw-save],[data-cgw-remove],[data-cgw-close],[data-cgw-edit]');
    if(!b)return;
    var box=b.closest('[data-cgw]');if(!box)return;
    e.preventDefault();
    if(b.hasAttribute('data-cgw-save'))save(box);
    else if(b.hasAttribute('data-cgw-remove'))remove(box);
    else if(b.hasAttribute('data-cgw-edit'))open(box,true);
    else{open(box,false);if(box.getAttribute('data-on')!=='true'){var tg=box.querySelector('[data-cgw-toggle]');if(tg)tg.checked=false;}}
  });

  /* Varukorgen ritas om av temat när något ändras – kontrollera då att inslagningen stämmer */
  ['cart:build','cart:updated','ajaxProduct:added'].forEach(function(ev){document.addEventListener(ev,soonSync);});
  function watch(){
    var lists=document.querySelectorAll('#CartDrawer [data-products], #CartPageForm [data-products]');
    if(window.MutationObserver)lists.forEach(function(l){if(l.__cgw)return;l.__cgw=1;new MutationObserver(soonSync).observe(l,{childList:true});});
  }
  if(document.readyState!=='loading'){watch();soonSync();}else document.addEventListener('DOMContentLoaded',function(){watch();soonSync();});
})();
